const possibleOnDeckEvents = {
  createProgramYear: {
    icon: 'date_range',
    title: 'Create a new Program Year',
    nextStepDescription: 'The first step in creating Readiness Rates is to create a new program year. If you are ready to create Readiness Rates, click this button.',
    actionType: 'component',
    component: 'create-program-year-dlg'
  },
  providerFileUpload: {
    icon: 'cloud_upload',
    title: 'Upload the Provider File',
    // Note, Enrollment file can actually be uploaded
    nextStepDescription: 'This action will populate the database with providers for the new program year. This must be done before the Enrollment File can be uploaded. Be sure to fix all errors that the system identifies.',
    uri: 'api/import/UploadFile?uploadFileType=Provider',
    actionType: 'uploadProvider'
  },
  enrollmentFileUpload: {
    icon: 'cloud_upload',
    uri: 'api/import/UploadFile?uploadFileType=Enrollment',
    title: 'Upload the Enrollment File',
    nextStepDescription: 'This action populates the database with child enrollment records for the new program year. This must be done before the FLKRS Assessment data can be uploaded. The system will attempt to automatically match child enrollment records to providers, but be sure to fix all errors that the system identifies.',
    actionType: 'uploadEnrollment'
  },
  startPhaseIIDisabledProvider: {
    icon: 'error',
    title: 'Errors Found with the Provider Data',
    buttonText: 'Review Providers',
    to: { name: 'Provider File', query: { reduceToErrors: true } },
    // Note, Enrollment file can actually be uploaded
    nextStepDescription: 'The system has found errors with the data uploaded from the Provider File. The errors must be resolved before the Enrollment File can be uploaded. Click this button to view the errors.',
    actionType: 'buttonNav'
  },
  startPhaseIIDisabledEnrollment: {
    icon: 'error',
    title: 'Errors Found with the Enrollment Data',
    nextStepDescription: 'Resolve Errors with enrollment data before proceeding',
    buttonText: 'Review Enrollments',
    to: { name: 'Enrollment File', query: { reduceToErrors: true } },
    actionType: 'buttonNav'
  },
  startPhaseIIEnabled: {
    icon: 'double_arrow',
    title: 'Start Phase II',
    uri: 'api/arrp/StartPhaseII',
    confirmTitle: 'Please Confirm',
    confirmDescription: 'Start Phase II?',
    confirmButtonText: 'Start',
    nextStepDescription: 'This action runs a number of processes within the database so that it can be ready for the FLKRS Assessment File. This action will lock down the ability to upload new Proivder and Enrollment Files but users will still have the ability to modify the existing data. Click this button to Start Phase II.',
    actionType: 'buttonUri'
  },
  flkrsFileUpload: {
    icon: 'cloud_upload',
    title: 'Upload the FLKRS Assessment File',
    nextStepDescription: 'This action populates the database with FLKRS Assessment data. Once the assessment data has been uploaded, OEL will have the ability to run the automatic match process.',
    uri: 'api/import/UploadFile?uploadFileType=FLKRS',
    actionType: 'uploadFLKRS'
  },
  enrollmentToFLKRSAutoMatch: {
    icon: 'swap_horiz',
    title: 'Run the Automatic Match Process',
    uri: 'api/arrp/StartAutoMatch',
    confirmTitle: 'Please Confirm',
    confirmDescription: 'Run the Automatic Match Process?',
    confirmButtonText: 'Run',
    nextStepDescription: 'The system will compare enrollment records to assessment records and match children based on defined rules. OEL will have the ability to manually match child records that could not be automatically matched. Click this button to run the match process.',
    actionType: 'buttonUri'
  },
  calculatePreliminaryRR: {
    icon: 'poll',
    title: 'Calculate Preliminary Readiness Rates',
    uri: 'api/arrp/CalculatePreliminaryRR',
    confirmTitle: 'Please Confirm',
    confirmDescription: 'Calculate Preliminatry Readiness Rates?',
    confirmButtonText: 'Calculate',
    nextStepDescription: 'The system will calculate Preliminary Readiness Rates for all providers. Once this action is completed, OEL will have the option to publish Preliminary Readiness Rates to the providers. Click this button to calculate Preliminary Readiness Rates.',
    actionType: 'buttonUri'
  },
  publishPreliminaryRR: {
    icon: 'publish',
    title: 'Publish Preliminary Readiness Rates',
    nextStepDescription: 'This action will publish all Preliminary Readiness Rates to providers. It also opens the Verification of Children Served and enables the Provider Dispute Process. Please note, the general public will not have access to Preliminary Readiness Rates.',
    actionType: 'component',
    component: 'PublishPrelimRRDlg'
  },
  calculateFinalRR: {
    icon: 'poll',
    title: 'Calculate Final Readiness Rates',
    uri: 'api/arrp/CalculateFinalRR',
    confirmTitle: 'Please Confirm',
    confirmDescription: 'Calculate Final Readiness Rates?',
    confirmButtonText: 'Calculate',
    nextStepDescription: 'The system will calculate Final Readiness Rates for all providers. Once this action is completed, OEL will have the option to publish Final Readiness Rates to the providers. Click this button to calculate Final Readiness Rates.',
    actionType: 'buttonUri'
  },
  publishFinalRR: {
    icon: 'publish',
    title: 'Publish Final Readiness Rates',
    nextStepDescription: 'This action will publish all Final Readiness Rates to providers and the general public. It is the final step in the Annual Readiness Rates Process. Click this button to publish Final Readiness Rates.',
    actionType: 'component',
    component: 'PublishFinalRRDlg'
  },
  completeProgramYear: {
    icon: 'publish',
    title: 'Prepare for Next Program Year',
    nextStepDescription: 'The purpose of this task is to prepare the VPKRR website for the upcoming Program Year. ARRP Admins should complete this task at the same time that they are ready to start the Annual Readiness Rates Process for a new Program Year. If you are ready to start the Annual Readiness Rates Process for a new Program Year, click this button.',
    actionType: 'component',
    component: 'ConfirmCompleteProgramYearDlg'
  }
};

export default { ...possibleOnDeckEvents }
